import React from 'react';
import { SubHeading, Text } from '../typography';
import { NotFound } from './Article.style';

interface ArticleNotFoundProps {
  noArticles?: boolean;
}

const ArticleNotFound: React.FC<ArticleNotFoundProps> = ({ noArticles }) => {
  return (
    <NotFound data-testid="article-not-found">
      <SubHeading data-testid="article-not-found-header" fontSize={32}>
        {noArticles ? 'No Articles' : 'Article Not Found'}
      </SubHeading>
      {noArticles ? (
        <Text data-testid="article-no-articles">This category has no articles.</Text>
      ) : (
        <>
          <Text>Oops! The page you are looking for does not exist.</Text>
          <Text>It might have been moved or deleted.</Text>
        </>
      )}
    </NotFound>
  );
};

export default ArticleNotFound;
